import { Div } from '@codesuma/baseline'
import push from '../../../services/push'
import style from './index.module.css'

// Notifications on/off, shown as a labeled settings row in the menu. Native
// (iOS/Android) only — it hides itself on the web, which has no push path.
// Turning it off deletes this device's push token; turning it on runs the OS
// permission + register flow.
export const NotificationsRow = () => {
    const base = Div()
    base.addClass(style.base)
    if (!push.isSupported()) {
        base.style({ display: 'none' })
        return base
    }

    const label = Div('Notifications')
    label.addClass(style.label)

    const toggle = Div()
    toggle.addClass(style.toggle)
    const knob = Div()
    knob.addClass(style.knob)
    toggle.append(knob)

    const render = (on: boolean) => {
        if (on) toggle.addClass(style.on)
        else toggle.removeClass(style.on)
    }

    // Paint the real state (OS permission + the user's choice) once known.
    push.isEnabled().then(render)

    let busy = false
    toggle.el.onclick = async () => {
        if (busy) return
        busy = true
        const wantOn = !toggle.el.classList.contains(style.on)
        render(wantOn) // optimistic — corrected below if the OS says no
        const on = await push.setEnabled(wantOn)
        render(on)
        if (wantOn && !on) {
            alert('Notifications are turned off for Papa List in your phone settings. Allow them there, then try again.')
        }
        busy = false
    }

    base.append(label, toggle)
    return base
}
